import type { ClientCancellationLineStatus } from '../../types/clientCancellationLines';

const FINAL: ClientCancellationLineStatus[] = ['Encerrado'];

const TRANSITIONS: Record<ClientCancellationLineStatus, ClientCancellationLineStatus[]> = {
  Agendado: ['ClienteAvisado'],
  ClienteAvisado: ['CancelamentoConfirmado', 'NaoCancelou'],
  CancelamentoConfirmado: ['Encerrado'],
  NaoCancelou: ['Encerrado'],
  Encerrado: [],
};

export function podeTransicionarClientCancellationStatus(
  de: ClientCancellationLineStatus,
  para: ClientCancellationLineStatus
): boolean {
  if (de === para) return false;
  if (FINAL.includes(de)) return false;
  return (TRANSITIONS[de] ?? []).includes(para);
}

export function proximosStatusClientCancellation(
  atual: ClientCancellationLineStatus
): ClientCancellationLineStatus[] {
  if (FINAL.includes(atual)) return [];
  return TRANSITIONS[atual] ?? [];
}
